import { useTheme } from '@emotion/react';
import { Grid, Typography, Box, Divider, useMediaQuery, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect } from 'react';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import { getSplitName } from '../../Utils/Helpers/stringHelper';
import React from 'react';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  fieldNameValue: {
    fontWeight: 400,
    color: '#7A869A',
  },
  sectionLabel: {
    fontWeight: 400,
    overflow: 'visible',
    padding: 2,
    textAlign: 'center',
    backgroundColor: '#000137 !important',
    color: '#fff',
    width: '100%',
    margin: '10px 0px',
  },
  fieldName: {
    color: '#7A869A',
    overflow: 'visible',
  },
  fieldValue: {
    color: '#061938',
    wordBreak: 'break-all',
    padding: '0px',
  },
  fieldContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'align-items': 'center',
      'justify-content': 'space-between',
      'max-width': '100%',
      display: 'flex',
      width: '100%',
    },
  },
  fieldKeyContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      'text-transform': 'capitalize',
      color: '#7A869A',
    },
    margin: '8px 0px !important',
  },
  fieldValueContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      color: '#061938',
    },
    margin: '8px 0px !important',
  },
  li: {
    textAlign: 'left',
    padding: theme.spacing(1),
    paddingLeft: '5px',
  },
  tableHeaderRow: {
    background: '#000137 !important',
  },
  tableHeaderCell: {
    'font-style': 'normal',
    'font-weight': '600',
    'font-size': '12px',
    'text-transform': 'capitalize',
    color: '#fff',
    whiteSpace: 'normal',
    padding: 5,
    textAlign: 'center',
    '&>:nth-child(5)': {
      maxWidth: '100px',
    },
  },
  tableBodyCell: {
    color: '#061938',
    'font-size': '14px',
    'font-style': 'normal',
    'font-weight': '400',
    whiteSpace: 'normal',
    textAlign: 'center',
  },
  userSign: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '120px',
    marginLeft: '10px',
  },
}));

const SummaryToPrint = React.forwardRef((props, ref) => {
  const { formJson, data, applicationState, getValues, image } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const checkFormOptions = (value) => {
    let combinedValues = [];
    let optionsArray = Object.values(applicationState.formOptions);
    for (let i = 0; i < optionsArray.length; i++) {
      const element = optionsArray[i];
      if (Array.isArray(element)) {
        combinedValues.push(...element);
      }
    }
    if (combinedValues.some((el) => el.value === value)) {
      return combinedValues.find((el) => el.value === value).label;
    } else if (value === 'true' || value === 'false') {
      return value === 'true' ? 'Yes' : 'No';
    } else {
      return value;
    }
  };

  const getFieldValue = (fieldName) => {
    try {
      const name = 'data[' + fieldName + ']';
      const keysArray = getSplitName(name, '', true) || [];
      let str = '';
      for (let i = 0; i < keysArray.length; i++) {
        const element = keysArray[i];
        if (i === 0) {
          str = element;
        } else {
          if (isNaN(element)) {
            str = `${str}["${element}"] && ${str}["${element}_select"] || ${str}["${element}"] && ${str}["${element}"]`;
          } else {
            str = `${str}[${element}] && ${str}[${element}]`;
          }
        }
      }
      return checkFormOptions(eval(str)); //covert string to executable
    } catch {
      console.log('error in eval');
    }
  };

  const getNestedData = (name, structure) => {
    const flatStructureData = structure.map((a) => {
      return { name: a?.name, label: a?.label };
    });
    let dataByName;
    if (/\d/.test(name)) {
      dataByName = getFieldValue(name);
    } else {
      dataByName = data[name] || [];
    }
    const allData = dataByName?.map((el) => {
      let obj = {};
      flatStructureData?.forEach((item) => {
        obj[item.label] = item.name.includes('semesterNumber') || item.name.includes('yearNumber') ? el[item?.name]?.replace(/\D/g, '') : el[item?.name];
      });
      return obj;
    });
    return allData;
  };

  const LastDivider = () => {
    return (
      <Grid item xs={12} lg={12} md={12}>
        <Divider className={classes.divider} />
      </Grid>
    );
  };

  const returnProperValue = (value) => {
    return value ? value : '-';
  };

  const getArrayValues = (values) => {
    let arrayValues = '';
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      if (i === values.length - 1) {
        arrayValues = arrayValues + `${element?.Program_Plan__r?.Name}`;
      } else {
        arrayValues = arrayValues + `${element?.Program_Plan__r?.Name},`;
      }
    }
    return arrayValues === '' ? '-' : arrayValues;
  };

  const formData = applicationState?.form;
  const programs =
    applicationState?.applicationData?.applicationPrograms?.map((items) => {
      return items?.Program_Plan__r?.Name;
    }) || [];

  return (
    <div ref={ref} style={{ padding: '20px' }}>
      <Box id="divToPrint">
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <img
            src={'https://flameprod.blob.core.windows.net/data/LOGO_VVI%20_with%20name.png'}
            alt="logo"
            style={{
              height: '140px',
              width: '140px',
              marginTop: '10px',
            }}
          />
          <Box component={'div'} width={'60%'} textAlign={'center'}>
            <Typography component={'h6'} sx={{ fontSize: '22px', fontWeight: '700' }}>
              VAGDEVI VILAS SCHOOL
            </Typography>
            <Typography component={'h6'} sx={{ fontSize: '14px', fontWeight: '700' }}>
              Affiliated to CBSE, New Delhi
            </Typography>
            <Typography component={'h6'} sx={{ fontSize: '14px', fontWeight: '500', textWrap: 'wrap' }}>
              No. 218, Dommasandra Road, Varthur, Bengaluru - 560087 Karnataka India
            </Typography>
            <Typography component={'h6'} sx={{ fontSize: '14px', fontWeight: '500', textWrap: 'wrap' }}>
              Phone: 8050071900 Email: info@vvi.edu.in, Website: www.vvi.edu.in
            </Typography>
          </Box>
          <img
            src={image}
            alt="logo"
            style={{
              height: '140px',
              width: '140px',
              marginTop: '10px',
              objectFit: 'contain',
            }}
          />
        </Grid>
        {applicationState?.applicationData?.application?.Name && (
          <Grid container spacing={1} style={{ margin: '20px 0px' }}>
            <Grid item md={6}>
              <Typography className={`${classes.fieldName} ${classes.fieldNameValue}`} variant="h5">
                Application Number :
              </Typography>
            </Grid>
            <Grid item md={6}>
              <Typography className={`${classes.fieldName} ${classes.fieldNameValue}`} variant="h5">
                {applicationState?.applicationData?.application?.Application_Number__c || '-'}
              </Typography>
            </Grid>
          </Grid>
        )}
        <Box component={'div'} marginTop={'20px'}>
          {formJson?.map((step, index) => {
            return step?.sections?.map((section, sectionIndex) => {
              const sectionShouldOnlyBeVisible = section.sectionVisible === true && section?.sectionId !== 'documentUpload';
              return (
                sectionShouldOnlyBeVisible && (
                  <div container spacing={1}>
                    {section?.sectionName && (
                      <div align="left" marginBottom={isMobileScreen ? theme.spacing(1) : theme.spacing(1)} className={classes.sectionLabel} fontSize="20px">
                        {`${section?.summaryName ? section?.summaryName : section?.sectionName} `}
                      </div>
                    )}
                    <Grid container xs={12} margin={1}>
                      {section?.sectionId === 'basket' ? (
                        <>
                          {programs?.map((items, index) => {
                            const getProgramData = formData?.programs?.find((programItem) => {
                              return programItem?.programPlanName === items;
                            });
                            return (
                              <Grid item container key={index} xs={12} spacing={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'} className={classes.fieldContainer}>
                                <Grid item sm={6} md={6} lg={6} textAlign="left" className={classes.fieldKeyContainer}>
                                  <Typography variant="h5" className={`${classes.fieldName} ${classes.fieldNameValue}`}>
                                    {getProgramData?.programBasket || ''}
                                  </Typography>
                                </Grid>
                                <Grid item sm={6} md={6} lg={6} textAlign="left" className={classes.fieldValueContainer}>
                                  <Typography className={`${classes.fieldValue} ${classes.fieldNameValue}`} variant="h5">
                                    {getProgramData?.programPlanName || ''}
                                  </Typography>
                                </Grid>
                              </Grid>
                            );
                          })}
                        </>
                      ) : (
                        section.fields.map((field, fieldIndex) => {
                          const nestedFiledArray = field?.type === 'array' && getNestedData(field.name, field.fieldsArray, data);
                          const normalFields = getFieldValue(field.name, applicationState.formOptions);
                          const isRuleApplied = field?.rule?.effect === 'SHOW' ? getValues(`${field?.rule?.condition?.scope}`) === field?.rule?.condition?.expectedValue : true;
                          const isRuleHided = field?.rule?.effect === 'HIDE' ? getValues(`${field?.rule?.condition?.scope}`) === field?.rule?.condition?.expectedValue : false;

                          // FIL
                          (nestedFiledArray || [])?.forEach((items) => {
                            if (items?.undefined) {
                              items['Country__c'] = items?.undefined?.Country__c;
                              delete items.undefined;
                            }
                          });
                          return nestedFiledArray && nestedFiledArray?.length > 0 && isRuleApplied && isRuleHided === false ? (
                            <Grid item container spacing={2} xs={12} md={12} lg={12} style={{ marginTop: '2px' }}>
                              <TableContainer style={{ overflow: 'hidden' }}>
                                <Table aria-label="customized table">
                                  <TableHead>
                                    <TableRow className={classes.tableHeaderRow}>
                                      {Object.keys(nestedFiledArray[0]).map((column, index) => {
                                        let columnName = column;
                                        if (column.includes('CGPA/GPA/Percentage/Points')) {
                                          columnName = column.split('CGPA/GPA/Percentage/Points')[0];
                                        } else {
                                          columnName = column;
                                        }
                                        return (
                                          <TableCell key={index} className={classes.tableHeaderCell}>
                                            <Typography
                                              style={{
                                                wordWrap: 'normal',
                                                textAlign: 'center',
                                              }}
                                            >
                                              {columnName}
                                            </Typography>
                                          </TableCell>
                                        );
                                      })}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {nestedFiledArray.map((row, rowIndex) => (
                                      <TableRow key={rowIndex}>
                                        {Object.values(row).map((value, colIndex) => (
                                          <TableCell key={colIndex} className={classes.tableBodyCell}>
                                            {value ? value : '-'}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          ) : field?.fieldId ? (
                            <>
                              {/* For Normal Fields */}
                              {normalFields && isRuleApplied && isRuleHided === false ? (
                                <Grid item container xs={12} spacing={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'} className={classes.fieldContainer}>
                                  <Grid item sm={6} md={6} lg={6} textAlign="left" className={classes.fieldKeyContainer}>
                                    <Typography variant="h5" className={`${classes.fieldName} ${classes.fieldNameValue}`}>
                                      {field?.label}
                                    </Typography>
                                  </Grid>
                                  <Grid item sm={6} md={6} lg={6} textAlign="left" className={classes.fieldValueContainer}>
                                    <Typography className={`${classes.fieldValue} ${classes.fieldNameValue}`} variant="h5">
                                    {field && typeof normalFields === 'string' || 'number' ? (returnProperValue(normalFields) === 'nulltestnoncore@gmail.com' ? '-' : returnProperValue(normalFields)) : getArrayValues(normalFields)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              ) : null}
                              {section.fields?.length - 1 === fieldIndex && <LastDivider />}
                            </>
                          ) : (
                            <>
                              {/* For Country Type of fields */}
                              {isRuleApplied && isRuleHided === false
                                ? field?.options.map((el) => {
                                    const addressTypeFields = getFieldValue(`${field.name}${el.fieldId}`, applicationState.formOptions);
                                    return (
                                      <>
                                        {addressTypeFields ? (
                                          <Grid item container xs={12} spacing={2} display={'flex'} justifyContent={'space-between'} alignItems={'start'} className={classes.fieldContainer}>
                                            <Grid item sm={6} md={6} lg={6} textAlign="left" className={classes.fieldKeyContainer}>
                                              <Typography className={`${classes.fieldName} ${classes.fieldNameValue}`} variant="h5">
                                                {el?.label}
                                              </Typography>
                                            </Grid>
                                            <Grid item sm={6} md={6} lg={6} textAlign="left" className={classes.fieldValueContainer}>
                                              <Typography className={`${classes.fieldValue} ${classes.fieldNameValue}`} variant="p">
                                                {returnProperValue(addressTypeFields)}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        ) : null}
                                      </>
                                    );
                                  })
                                : null}
                            </>
                          );
                        })
                      )}
                    </Grid>
                  </div>
                )
              );
            });
          })}
        </Box>
        <div align="left" marginBottom={isMobileScreen ? theme.spacing(1) : theme.spacing(1)} className={classes.sectionLabel} fontSize="20px">
          Declaration
        </div>
        <Typography fontWeight={500} color="primary" align="left" variant="subtitle2" fontSize={'16px'} sx={{ color: '#000000' }}>
          I Do hereby give an undertaking to abide by the following rules and regulations laid downby the school Management.
        </Typography>
        <ol>
          <li className={classes.li}>We shall co-operate with the school authorities and the concerned class/subject teachers in the development of our child.</li>
          <li className={classes.li}>We understand that misbehaviour with any staff of the school is not acceptable and in such an event, management reserves the right to take any disciplinary action including the withdrawal of admission granted to the child.</li>
          <li className={classes.li}>Communication/Correspondence with the class/subjects teachers will be during school working hours through the Principal/Co-ordinator.</li>
          <li className={classes.li}>Our relationship with all the staff of the school will be courteous and polite at all times.</li>
          <li className={classes.li}>We will respect all school activities to promote our ancient Indian culture and will not object in any way to them.</li>
          <li className={classes.li}>We will visit the school only at the stipulated time for any enquiries related to our child.</li>
          <li className={classes.li}>We will take care not to send mobile phones/iPods,any such electronic gadgets and also see that our child does not wear any valuable ornament. </li>
          <li className={classes.li}>We have no objection to the singing of the National Anthem,Vande Mataram,etc and chanting of shlokas and Bagawad Gita by Our son/daughter. </li>
          <li className={classes.li}>We shall Strictly abide by the school uniform norms irrespective of our individual caste/creed/religion. </li>
          <li className={classes.li}>We understand that our son/daughter must start attending classes within fifteen days of reopening of the school,failing which the admission will be cancelled automatically.We shall intimate and take permission from Management for leave of any sort, before the reopening. </li>
          <li className={classes.li}>We understand that cancellation of admission is not entertained and there is no refund/transfer of fees once paid. </li>
          <li className={classes.li}>Admission process is initated by: {applicationState.applicationData.application.admissionProcessIsInitiatedBy}</li> 
        </ol>
        <Box component={'div'} className={classes.userSign}>
          <Typography>Date: {moment().format('DD/MM/YYYY')}</Typography>
          <Typography>Place:</Typography>
        </Box>
      </Box>
    </div>
  );
});

export default SummaryToPrint;
